module.exports = __webpack_public_path__ + "media/images/icons/filled/dashboard-c1986ec03b993d536071e4f2f8190862.svg";